import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { Mail, Lock, Loader2 } from "lucide-react";
import API, { formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const Login = () => {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      toast.success("¡Bienvenida de vuelta!");
      navigate(params.get("next") || "/");
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="grain flex min-h-screen items-center justify-center bg-[#4b3a2f] px-4 pb-16 pt-[100px]" data-testid="login-page">
      <div className="w-full max-w-md rounded-3xl bg-[#faf7f2] p-10 shadow-[0_30px_80px_rgba(0,0,0,0.35)]">
        <img src="/logo-emblem.png" alt="AWEN" className="mx-auto h-20 w-20 rounded-full ring-1 ring-[#c9a24b]/40" />
        <h1 className="mt-6 text-center font-serif-d text-4xl font-semibold text-[#4b3a2f]">Bienvenido de nuevo</h1>
        <p className="mt-2 text-center text-sm text-[#6b5b52]">Inicia sesión para continuar tu camino</p>

        <form onSubmit={submit} className="mt-8 space-y-5">
          <label className="block">
            <span className="text-xs font-semibold uppercase tracking-wider text-[#a47b52]">Correo electrónico</span>
            <div className="mt-2 flex items-center gap-3 rounded-xl border border-[#4b3a2f]/15 bg-white px-4 focus-within:border-[#c9a24b]">
              <Mail size={16} className="text-[#a47b52]" />
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="tu@correo.com"
                data-testid="login-email-input"
                className="w-full bg-transparent py-3.5 text-sm text-[#4b3a2f] outline-none"
              />
            </div>
          </label>
          <label className="block">
            <span className="text-xs font-semibold uppercase tracking-wider text-[#a47b52]">Contraseña</span>
            <div className="mt-2 flex items-center gap-3 rounded-xl border border-[#4b3a2f]/15 bg-white px-4 focus-within:border-[#c9a24b]">
              <Lock size={16} className="text-[#a47b52]" />
              <input
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                data-testid="login-password-input"
                className="w-full bg-transparent py-3.5 text-sm text-[#4b3a2f] outline-none"
              />
            </div>
          </label>

          {error && (
            <p data-testid="login-error" className="rounded-xl bg-[#c85a48]/10 px-4 py-3 text-sm text-[#c85a48]">{error}</p>
          )}

          <button
            type="submit"
            disabled={loading}
            data-testid="login-submit-button"
            className="flex w-full items-center justify-center gap-2 rounded-full bg-[#4b3a2f] py-4 text-sm font-semibold text-[#f2e9dd] transition-colors hover:bg-[#c9a24b] hover:text-[#4b3a2f]"
          >
            {loading && <Loader2 size={16} className="animate-spin" />} Iniciar sesión
          </button>
        </form>

        <p className="mt-6 text-center text-sm text-[#6b5b52]">
          ¿Aún no tienes cuenta?{" "}
          <Link to="/registrarse" data-testid="login-to-register" className="font-semibold text-[#a47b52] hover:underline">
            Regístrate gratis
          </Link>
        </p>
      </div>
    </div>
  );
};

export default Login;
